function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChase = function SvgChase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1957a3"
    },
    d: "M0 0h40v26H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.824 5.211c-.312 0-.52.26-.52.52v3.846h10.239l-4.678-4.366h-5.041m9.978 5.613c0-.312-.26-.52-.52-.52h-3.846v10.239l4.418-4.626v-5.093m-5.665 9.978c.312 0 .52-.26.52-.52v-3.846H12.522l4.626 4.418h5.041m-9.978-5.665c0 .312.26.52.52.52h3.846V5.522l-4.366 4.626v5.041",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgChase;